import React, { useState } from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { FaSortUp, FaSortDown, FaSort } from "react-icons/fa";
import { BsThreeDots } from "react-icons/bs";
import { FiEdit } from "react-icons/fi";
import { ImCross } from "react-icons/im";

import {
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Text,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  useDisclosure,
} from "@chakra-ui/react";
import { FiliacaoEditar } from "../Editar";
import { normalizeString } from "../../../../utils/masks";
import { useAppContext } from "../../../../../Context/MessageContextProvider";
import Swal from "sweetalert2";

export const FiliacaoTable = ({
  data,
  columns,
  filiacoes,
  setFieldValue,
  idCrianca,
  edit,
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { idPessoaFisicaFilho } = useAppContext();
  const [selectedFiliacao, setSelectedFiliacao] = useState();
  const [vinculoBlocked] = useState(true);

  const excluirFiliacao = (row) => {
    setFieldValue(
      "filiacoes",
      filiacoes.filter((filiacao, index) => {
        if (filiacao.id !== null) {
          return filiacao.id !== row.original.id;
        } else {
          return !(
            filiacao.id === null &&
            filiacoes[index].nome === row.original.nome &&
            index === row.index
          );
        }
      })
    );

    setFieldValue("situacaoPai", "");
    setFieldValue("situacaoMae", "");
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,

    prepareRow,
    //gotoPage,

    page,
    //setPageSize,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        filters: [],
        pageIndex: 0,
        sortBy: [
          {
            id: "tipoFiliacao",
            desc: false,
          },
        ],
        pageSize: 4,
      },
    },
    useFilters,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        ...columns,
        {
          id: "moreInfo",
          Header: "Opções",
          Cell: ({ row }) => (
            <Flex justifyContent="center">
              <Menu>
                <MenuButton
                  as={IconButton}
                  icon={<BsThreeDots color="#fff" fontSize="20px" />}
                  variant={"link"}
                  cursor={"pointer"}
                  backgroundColor="#95BCBF"
                  rounded={100}
                  p={2}
                />
                <MenuList>
                  {row.original.nome !== "Desconhecido" &&
                    row.original.nome !== "Desconhecida" &&
                    normalizeString(row.original.nome) !==
                      normalizeString("Sem informação") && (
                      <MenuItem
                        p={2}
                        color={"#374BCE"}
                        onClick={() => {
                          setSelectedFiliacao(row.original);
                          onOpen();
                        }}
                      >
                        <FiEdit />
                        <Text ml="5px">Editar</Text>
                      </MenuItem>
                    )}
                  <MenuItem
                    p={2}
                    color={"red.500"}
                    onClick={() => {
                      const filhos =
                        row.original.filhos &&
                        row?.original?.filhos
                          .filter(
                            (item) => item?.idCriancaFilho !== Number(idCrianca)
                          )
                          .map((item) => item);

                      if (edit) {
                        if (filhos && filhos.length > 0) {
                          Swal.fire({
                            title: "Atenção!",
                            text: "Existe(m) irmão(s) vinculado(s). Deseja Prosseguir com a exclusão da Filiação?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#169499",
                            cancelButtonColor: "#169499",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              excluirFiliacao(row);
                            }
                          });
                        } else {
                          Swal.fire({
                            title: "Atenção!",
                            text: " Deseja realmente excluir a filiação?",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#169499",
                            cancelButtonColor: "#169499",
                            confirmButtonText: "Sim",
                            cancelButtonText: "Não",
                          }).then((result) => {
                            if (result.isConfirmed) {
                              excluirFiliacao(row);
                            }
                          });
                        }
                      } else {
                        Swal.fire({
                          title: "Atenção!",
                          text:
                            idPessoaFisicaFilho &&
                            row.original?.id > 0 &&
                            row.original?.idTipoRelacionamento
                              ? "Essa Filiação possui vínculo(s) com irmão(s) em comum. Ao excluir o vínculo será perdido. Deseja prosseguir?"
                              : " Deseja realmente excluir a filiação?",
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#169499",
                          cancelButtonColor: "#169499",
                          confirmButtonText: "Sim",
                          cancelButtonText: "Não",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            excluirFiliacao(row);
                          }
                        });
                      }
                    }}
                  >
                    <ImCross />
                    <Text ml="5px">Excluir</Text>
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          ),
        },
      ]);
    }
  );

  // function irParaPagina(pagina) {
  //   gotoPage(pagina);
  // }

  // function selecionarTotalItens(nItens) {
  //   setPageSize(nItens);
  // }

  return (
    <Flex flexDir="column" overflowX="auto">
      <Table {...getTableProps} backgroundColor="white" mt="5px">
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps({
                    ...column.getHeaderProps(
                      !(column.Header === "Opções") &&
                        column.getSortByToggleProps({ title: undefined })
                    ),
                  })}
                  key={index}
                >
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent={
                      column.Header === "Opções" ? "center" : "flex-start"
                    }
                  >
                    <Text as="p">{column.render("Header")}</Text>

                    {column.Header !== "Opções" ? (
                      <Flex pl={1} alignItems="center">
                        {column.isSorted ? (
                          column.isSortedDesc ? (
                            <Icon as={FaSortDown} boxSize="14px" />
                          ) : (
                            <Icon as={FaSortUp} boxSize="14px" />
                          )
                        ) : (
                          <Icon as={FaSort} boxSize="14px" />
                        )}
                      </Flex>
                    ) : (
                      ""
                    )}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  return (
                    <Td
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      lineHeight="21.6px"
                      color="#797A80"
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      {selectedFiliacao && (
        <FiliacaoEditar
          isOpen={isOpen}
          onOpen={onOpen}
          onClose={() => {
            setSelectedFiliacao(null);
            onClose();
          }}
          filiacoes={filiacoes}
          setFieldValue={setFieldValue}
          selectedFiliacao={selectedFiliacao}
          idCrianca={idCrianca}
          vinculoBlocked={vinculoBlocked}
        />
      )}
    </Flex>
  );
};
